import { useCallback, useState } from "react";

/**
 * Selection state for a list that can remove several items at once.
 * `visibleIds` is the set controlled by Select all / Clear.
 */
export default function useBulkSelection(visibleIds) {
  const [selectMode, setSelectMode] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const allVisibleSelected =
    visibleIds.length > 0 &&
    visibleIds.every((id) => selectedIds.includes(id));

  const toggle = useCallback((id) => {
    if (id == null || id === "") return;
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  }, []);

  const selectAllVisible = useCallback(() => {
    setSelectedIds((prev) => {
      const every =
        visibleIds.length > 0 && visibleIds.every((id) => prev.includes(id));
      if (every) return prev.filter((id) => !visibleIds.includes(id));
      return [...new Set([...prev, ...visibleIds])];
    });
  }, [visibleIds]);

  const exitSelectMode = useCallback(() => {
    setSelectMode(false);
    setSelectedIds([]);
  }, []);

  const toggleSelectMode = useCallback(() => {
    setSelectMode((prev) => !prev);
    setSelectedIds([]);
  }, []);

  return {
    selectMode,
    selectedIds,
    setSelectedIds,
    allVisibleSelected,
    toggle,
    selectAllVisible,
    exitSelectMode,
    toggleSelectMode,
  };
}
